import { Component, Vue } from 'vue-property-decorator'


//components
import PortalAdminContent from '@/components/portalAdminContent/PortalAdminContent.vue'
import FieldSearch from '@/components/fieldSearch/FieldSearch.vue'

//wrappers
import {
    WForm,
    Box,
    WButton,
    WSubtitle
} from '@/components/wrappers';

@Component({
    components: {
      PortalAdminContent,
        FieldSearch,
        WForm,
        Box,
        WButton,
        WSubtitle
    }
})

export default class Page404 extends Vue {

	mounted(){
		document.title = "404! Página não Encontrada"
	}

}